import React from "react";
import "./Modal.css";

const Modal = ({
  isOpen,
  onClose,
  title,
  message,
  type = "info", // 'info', 'success', 'warning', 'error'
  showCancel = false,
  confirmText = "OK",
  cancelText = "Cancel",
  onConfirm = null,
  onCancel = null,
  isNarrow = false,
  titleIcon = null,
  bodyContent = null,
  showClose = true,
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  const getIcon = () => {
    switch (type) {
      case "success":
        return "✅";
      case "warning":
        return "⚠️";
      case "error":
        return "❌";
      default:
        return "ℹ️";
    }
  };

  const getTypeClass = () => {
    switch (type) {
      case "success":
        return "modal-success";
      case "warning":
        return "modal-warning";
      case "error":
        return "modal-error";
      default:
        return "modal-info";
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className={`modal-content ${getTypeClass()} ${
          isNarrow ? "modal-narrow" : ""
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3 className={`modal-title ${titleIcon ? "has-icon" : ""}`}>
            {titleIcon && (
              <span className="modal-title-icon" role="presentation">
                {titleIcon}
              </span>
            )}
            <span className="modal-title-text">{title}</span>
          </h3>
          {showClose && (
            <button className="modal-close" onClick={onClose}>
              ×
            </button>
          )}
        </div>
        <div className="modal-body">
          {bodyContent ? (
            bodyContent
          ) : (
            <div className="modal-message">
              {message.split("\n").map((line, index) => {
                if (line.startsWith("- ")) {
                  return (
                    <div key={index} className="modal-bullet-point">
                      • {line.substring(2)}
                    </div>
                  );
                }
                return (
                  <div key={index} className="modal-text-line">
                    {line}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className={`modal-footer ${showCancel ? "with-cancel" : ""}`}>
          <button
            className="modal-btn modal-btn-confirm"
            onClick={handleConfirm}
          >
            {confirmText}
          </button>
          {showCancel && (
            <button
              className="modal-btn modal-btn-cancel"
              onClick={onCancel || onClose}
            >
              {cancelText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
